import React from 'react'
import { ReactComponent as ChartIcon } from 'resources/svg/icons/size-guide.svg'
import { Modal } from 'components/Modal'
import { IconWrapper, SizingChartContent } from './styled'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

interface Props {
  setIsModalOpen: (isOpen: boolean) => void
  isModalOpen: boolean
  sizingChart: string
  sizeChartBottomBlock: CmsBlockData
  isSofia?: boolean
}

export const SizingChart = ({ setIsModalOpen, isModalOpen, sizingChart, sizeChartBottomBlock, isSofia }: Props) => {
  return (
    <>
      <IconWrapper
        onClick={() => setIsModalOpen(true)}
        isSofia={isSofia}
      >
        <ChartIcon />
        <span>
          Sizing chart
        </span>
      </IconWrapper>

      <Modal
        isOpen={isModalOpen}
        modalTitle='Here’s how to find your size.'
        handleCloseModal={() => setIsModalOpen(false)}
        type='normal'
      >
        <SizingChartContent>
          <div
            dangerouslySetInnerHTML={{
              __html: sizingChart
            }}
          />
          <div
            className='bottom-block'
            dangerouslySetInnerHTML={{
              __html: sizeChartBottomBlock?.content ?? ''
            }}
          />
        </SizingChartContent>
      </Modal>
    </>
  )
}
